export const ROUTES_WITHOUT_MENU_OPTIONS = [
  'atendimento-agendado/sala-de-espera',
  '/ativacao/conta-dependente-ativada',
  '/ativacao/conta-dependente-dados-atualizados',
  '/confirmando-sua-consulta',
]

export const ROUTES_WITH_NAVBAR_EXCEPTIONS = [
  '/ativacao/conta-dependente-ativada',
  '/ativacao/conta-dependente-dados-atualizados',
]

export const ROUTES_WITHOUT_AVATAR = [
  '/ativacao/conta-dependente-ativada',
  '/ativacao/conta-dependente-dados-atualizados',
  '/confirmando-sua-consulta',
]

export const ROUTES_WITHOUT_NAVBAR = [
  'login',
  'escolha',
  'redirecionar',
  'esqueci-senha',
  'trocar-senha',
  'termos-recusados',
  'confirmar-senha',
  'politicas-de-privacidade',
  'cadastro',
  'autenticacao-dois-fatores',
  'ativacao',
  'beep',
  'termos-resp-legal',
]
